import { createActions, createState, createReducer } from 'reduxsauce-crud'

const d = { deep: true }

export const MoodRedux = createActions(
  {
    // Custom actions
  },
  {
    prefix: 'MOOD_',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = MoodRedux
export const MoodTypes = Types
export default Creators

export const INITIAL_STATE = createState({
// custom state
},
{
  get: true,
})

export const reducer = createReducer(
  INITIAL_STATE, {
    // custom reducers
  },
  {
    defaultActions: {
      get: true,
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/Mood.js